import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-search-field',
  templateUrl: './search-field.component.html',
  styleUrls: ['./search-field.component.scss'],
})
export class SearchFieldComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {
  searchText = '';
  inputIsFocus: boolean;
  isSearch: boolean;

  private delayedSearch = new Subject<string>();
  @Input() searchDelay = 300; 
  private delayedObservable$ = this.delayedSearch.pipe(debounceTime(this.searchDelay));
  private delayedSubscription: Subscription;

  @Output() searchOn = new EventEmitter<string>();
  @Output() searchOnClick = new EventEmitter<boolean>();

  @Input() auto = false;
  private _initialValue: string | null = null;

  @Input()
  set initialValue(value: string | null) {
    this._initialValue = value;
    if (value !== null && value !== undefined) {
      this.searchText = value || '';
      this.isSearch = this.searchText.length > 0;
    } else {
      this.searchText = '';
      this.isSearch = false;
    }
  }

  get initialValue(): string | null {
    return this._initialValue;
  }

  private resetSearchObservable() {
    if (this.delayedSubscription) {
      this.delayedSubscription.unsubscribe();
      this.delayedSubscription = null;
    }
    this.delayedObservable$ = this.delayedSearch.pipe(debounceTime(this.searchDelay));
    this.delayedSubscription = this.delayedObservable$.subscribe(value => {
      if (this.auto) {
        this.searchOn.emit(value);
      }
    });
  }

  constructor() {
    this.resetSearchObservable();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['initialValue']) {
      const value = changes['initialValue'].currentValue;
      if (value !== null && value !== undefined) {
        this.searchText = value || '';
        this.isSearch = this.searchText.length > 0;
      } else {
        this.searchText = '';
        this.isSearch = false;
      }
    }
  }

  updSearch(value) {
    this.searchText = value;
    this.delayedSearch.next(value);
  }

  ngOnInit() {
    if (this.initialValue !== null && this.initialValue !== undefined) {
      this.searchText = this.initialValue || '';
      this.isSearch = this.searchText.length > 0;
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (this.initialValue !== null && this.initialValue !== undefined && this.initialValue !== '') {
        this.searchText = this.initialValue;
        this.isSearch = this.searchText.length > 0;
      }
    }, 0);
  }

  ngOnDestroy() {
    if (this.delayedSubscription) {
      this.delayedSubscription.unsubscribe();
      this.delayedSubscription = null;
    }
  }

  search() {
    this.searchOn.emit(this.searchText);
    this.searchOnClick.emit(true);
    this.isSearch = this.searchText.length > 0;
  }

  clearSearchInput() {
    this.searchOn.emit((this.searchText = null));
    this.isSearch = false;
  }
}
